import React from "react";
import styled from "styled-components";

export default function ProjectBox({ img, title, text, link }) {
  return (
    <LinkWrapper href={link} target="_blank" rel="noopener noreferrer">
      <Wrapper>
        <ImageContainer>
          <img src={img} alt={title} />
        </ImageContainer>
        <h3>{title}</h3>
        <p>{text}</p>
      </Wrapper>
    </LinkWrapper>
  );
}

// Styled-components
const LinkWrapper = styled.a`
  text-decoration: none;
  color: inherit;
  display: block;
`;

const Wrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  text-align: center;
  padding: 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }

  h3 {
    font-size: 1.2rem;
    margin: 15px 0 10px;
  }

  p {
    font-size: 0.9rem;
    color: #555;
  }
`;

const ImageContainer = styled.div`
  overflow: hidden;
  border-radius: 8px;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    transition: transform 0.4s ease, opacity 0.3s ease;
  }

  ${Wrapper}:hover & img {
    transform: scale(1.05);
    opacity: 0.85;
  }
`;
